import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ExecutingWorkflowEntry {
  executionId: string;
  projectId: string | undefined;
  startedAt: string;
}

interface ExecutingWorkflowsState {
  executingWorkflows: Map<string, ExecutingWorkflowEntry>;
}

interface ExecutingWorkflowsStore extends ExecutingWorkflowsState {
  markExecuting: (workflowId: string, entry: ExecutingWorkflowEntry) => void;
  markDone: (workflowId: string) => void;
  reset: () => void;
}

export const useExecutingWorkflowsStore = create<ExecutingWorkflowsStore>()(
  devtools(
    (set, get) => ({
      executingWorkflows: new Map(),

      markExecuting: (workflowId, entry) => {
        const next = new Map(get().executingWorkflows);
        next.set(workflowId, entry);
        set({ executingWorkflows: next }, false, "markExecuting");
      },

      markDone: (workflowId) => {
        const next = new Map(get().executingWorkflows);
        next.delete(workflowId);
        set({ executingWorkflows: next }, false, "markDone");
      },

      reset: () => {
        set({ executingWorkflows: new Map() }, false, "reset");
      },
    }),
    { name: "ExecutingWorkflowsStore" },
  ),
);
